import type { AttackPattern, EnemyDefinition } from '../types';

const QUICK_LIGHT: AttackPattern = {
  kind: 'quick',
  windupMs: 600,
  windowMs: 480,
  damageOnHit: 14,
  durabilityCorrect: 1,
  durabilityWrong: 2,
};

const QUICK_FAST: AttackPattern = {
  kind: 'quick',
  windupMs: 480,
  windowMs: 380,
  damageOnHit: 12,
  durabilityCorrect: 1,
  durabilityWrong: 2,
};

const HEAVY: AttackPattern = {
  kind: 'heavy',
  windupMs: 1200,
  windowMs: 700,
  damageOnHit: 26,
  durabilityCorrect: 1,
  durabilityWrong: 3,
};

const HEAVY_SLOW: AttackPattern = {
  kind: 'heavy',
  windupMs: 1500,
  windowMs: 800,
  damageOnHit: 34,
  durabilityCorrect: 2,
  durabilityWrong: 4,
};

const FEINT: AttackPattern = {
  kind: 'feint',
  windupMs: 700,
  windowMs: 500,
  damageOnHit: 0,
  durabilityCorrect: 0,
  durabilityWrong: 3,
};

const FEINT_FAST: AttackPattern = {
  kind: 'feint',
  windupMs: 500,
  windowMs: 380,
  damageOnHit: 0,
  durabilityCorrect: 0,
  durabilityWrong: 3,
};

export const ENEMIES: Record<string, EnemyDefinition> = {
  goblin: {
    type: 'goblin',
    displayName: 'Goblin Scout',
    maxHp: 1, // hp doesn't track HP-based fights; fatigue drives the kill window
    silhouetteId: 'goblin',
    fatigueThreshold: 3,
    attackBag: [QUICK_LIGHT, QUICK_LIGHT, QUICK_FAST],
    tier: 'low',
    goldRange: [15, 25],
    backgroundId: 'dawn',
  },
  wolf: {
    type: 'wolf',
    displayName: 'Dire Wolf',
    maxHp: 1,
    silhouetteId: 'wolf',
    fatigueThreshold: 3,
    attackBag: [QUICK_FAST, QUICK_FAST, QUICK_LIGHT, FEINT],
    tier: 'low',
    goldRange: [18, 30],
    backgroundId: 'dawn',
  },
  bandit: {
    type: 'bandit',
    displayName: 'Highway Bandit',
    maxHp: 1,
    silhouetteId: 'bandit',
    fatigueThreshold: 4,
    attackBag: [QUICK_LIGHT, HEAVY, FEINT, QUICK_FAST],
    tier: 'mid',
    goldRange: [32, 50],
    backgroundId: 'dusk',
  },
  ogre: {
    type: 'ogre',
    displayName: 'Cave Ogre',
    maxHp: 1,
    silhouetteId: 'ogre',
    fatigueThreshold: 5,
    attackBag: [HEAVY, HEAVY_SLOW, HEAVY, QUICK_LIGHT],
    tier: 'mid',
    goldRange: [55, 80],
    backgroundId: 'cave',
  },
  wraith: {
    type: 'wraith',
    displayName: 'Barrow Wraith',
    maxHp: 1,
    silhouetteId: 'wraith',
    fatigueThreshold: 5,
    attackBag: [FEINT, FEINT, FEINT_FAST, QUICK_FAST, HEAVY],
    tier: 'high',
    goldRange: [80, 120],
    backgroundId: 'crypt',
  },
};
